import { render, staticRenderFns } from "./policy-list.vue?vue&type=template&id=46271481&scoped=true&"
import script from "./policy-list.vue?vue&type=script&lang=js&"
export * from "./policy-list.vue?vue&type=script&lang=js&"
import style0 from "./policy-list.vue?vue&type=style&index=0&id=46271481&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46271481",
  null
  
)

export default component.exports